import ModalPortalFlag from './ModalPortalFlag'

export default ModalPortalFlag
// eslint-disable-next-line import/export
export * from './ModalPortalFlag'
